// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"427d938e","18":"1ff0fe0c","195":"7cc5e5d6","350":"b1b8326b","599":"e3cf1f6e","725":"ef3a1851","916":"8c234b99","985":"718f9306"}[chunkId] + ".chunk.js";
};